<template>
  <div>
    <tk-flex  between >
      <public-header :title="pageData.name || ''" show-back></public-header>
      <a-button type="primary" @click="edit" >
        编辑
      </a-button>
    </tk-flex>
    <a-spin :spinning="loading" class="full-width" style="min-height: 60vh;" >
      <div style="display: none;">.</div>
      <div class="full-width bg-white border-radius-12" v-if="pageData && pageData.objectId" >
        <Layout :showMenu="true" :menuList="menuList" :showMainImage="true" :defaultKeys="[0]" :activeKey.sync="key" :mainImage="true" :mainImageUrl="pageData.images[0]"  >
          <template slot="content" >
            <div class="font-14 font-bold m-b-20" style="color: #363B45" >{{ menuList[key].name }}</div>
            <div v-show="key === 0" style="height:100%">
              <a-row :gutter="[20,20]" class="font-12" style="color: #363B45" >
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" >
                  系列：{{ pageData.series.name }}
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" v-if="!pageData.isService"  >
                  电压v：{{ pageData.voltage.name }}
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" v-if="!pageData.isService"  >
                  容量AH：{{ pageData.capacity.name }}
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
                  {{pageData.isService ? '活动价' : '以旧换新价'}}：{{ pageData.tradePrice }}
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
                  {{pageData.isService ? '原价' : '直接购买价'}}：{{ pageData.price }}
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
                  商品积分：{{ pageData.points }}
                </a-col>
                <a-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8"  >
                  商品排序：{{ pageData.sort }}
                </a-col>
                <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24"  >
                  <div class="full-width" style="word-break: break-all;">商品描述：{{ pageData.introduce }}</div>
                </a-col>
                <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24"  >
                  <tk-flex>
                    <div class="unshrink">商品详情：</div>
                    <div v-html="pageData.details" class="p-15" style="height: 450px; width: 100%;overflow-y: scroll;border-radius: 6px;border: 1px solid #DBDDE1;" ></div>
                  </tk-flex>
                </a-col>
                <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24"  >
                  <tk-flex>
                    <div class="unshrink">商品图片：</div>
                    <tk-flex wrap>
                      <!-- <div v-for="(item, index) in pageData.images" :key="index" class="m-r-10 m-b-10" > -->
                        <viewer v-if="pageData.images.length" :images="pageData.images">
                          <img v-for="(item, index) in pageData.images" :key="index" :src="item" style="width: 120px;height:120px;object-fit:cover;margin-right: 5px;border-radius: 6px;border: 1px solid #DBDDE1;" />
                        </viewer>
                        <!-- <tk-image :width="120" :height="120" :src="item" style="" /> -->
                      <!-- </div> -->

                    </tk-flex>
                  </tk-flex>
                </a-col>
              </a-row>
            </div>
            <div v-show="key === 1" style="height:100%">
              <Area :region.sync="region"  />
              <a-card style="width: 100%" v-if="agentList.length" class="m-t-20" >
                <tk-flex slot="title" between middle >
                  <tk-flex meddle class="font-12" >
                    <div v-if="agentList[0].tradePrice === '' || !agentList[0].hasOwnProperty('tradePrice')" class="btn-blue" >默认</div>
                    <div v-else class="btn-yellow" >修改</div>
                    <div class=" m-l-12 m-t-2" >{{pageData.isService ? '活动价' : '以旧换新价'}}：</div>
                    <div class=" m-t-2" style="color: #FF2A58" >{{ agentList[0].tradePrice === '' || !agentList[0].hasOwnProperty('tradePrice') ? pageData.tradePrice : agentList[0].tradePrice }}</div>

                    <div class=" m-l-12 m-t-2" >{{pageData.isService ? '原价' : '直接购买价'}}：</div>
                    <div class=" m-t-2" style="color: #FF2A58" >{{ agentList[0].price === '' || !agentList[0].hasOwnProperty('tradePrice') ? pageData.price : agentList[0].price }}</div>
                  </tk-flex>
                </tk-flex>
                <a-spin :spinning="loading" class="p-x-8">
                  <a-row :gutter="[16,16]" class="public-clean-side full-width">
                    <div class="full-width">
                      <a-col
                        v-for="(s, index) in agentList"
                        :key="index"
                        :xs="12"
                        :sm="8"
                        :md="6"
                        :lg="4"
                      >
                        {{ s.winWinMerchant.nickName }}
                      </a-col>
                    </div>
                  </a-row>
                </a-spin>
              </a-card>
              <tk-flex v-else center middle class="font-12" style="height: 50vh;color: #808690;" >
                暂无授权信息
              </tk-flex>
            </div>
            <div v-show="key === 2" style="height:100%">
              <div class="font-12 m-b-20" style="color: #363B45">
                买赠类型：{{ pageData.giftType === '1' ? '全国买赠' : pageData.giftType === '2' ? '区域买赠' : '暂未开启' }}
              </div>
              <div v-if="pageData.giftType === '1'" >
                <tk-flex class="m-b-24">
                  <div class="font-12 unshrink" style="color: #363B45" >买赠主图：</div>
                  <div class="fill">
                    <viewer v-if="pageData.images.length" :images="[pageData.mainImage]">
                      <img :src="pageData.mainImage" style="width: 120px;height:120px;object-fit:cover;margin-right: 5px;border-radius: 6px;border: 1px solid #DBDDE1;" />
                    </viewer>
                  </div>
                </tk-flex>
                <tk-flex style="width: 100%">
                  <div class="font-12 unshrink" style="color: #363B45" >包含赠品：</div>
                </tk-flex>
                <div class="m-t-10 m-b-24">
                  <a-table
                    v-if="device !== 'mobile'"
                    style="width: 100%" :columns="columns" :data-source="data" bordered :pagination="false" :scroll="{x: 600}" size="small">
                    <div slot="image" slot-scope="text">
                      <viewer v-if="text" :images="[text]">
                        <img :src="text" style="width: 40px;height:40px;object-fit:cover;border-radius: 6px;border: 1px solid #DBDDE1;" />
                      </viewer>
                      <span v-else> 暂无 </span>
                    </div>
                    <div slot="gift" slot-scope="text, record">{{ record.giftData.name }}</div>
                  </a-table>
                  <div v-else>
                    <a-descriptions bordered v-for="(item,index) in data" :key="index" style="margin-bottom: 20px">
                      <a-descriptions-item
                        v-for="( itm, i) in columns" :key="`item${i}`"
                        :label="itm.title"
                      >
                        <div v-if="itm.dataIndex === 'image'">
                          <viewer v-if="item[itm.dataIndex]" :images="[item[itm.dataIndex]]">
                            <img :src="item[itm.dataIndex]" style="width: 40px;height:40px;object-fit:cover;border-radius: 6px;border: 1px solid #DBDDE1;" />
                          </viewer>
                          <span v-else> 暂无 </span>
                        </div>
                        <div v-else-if="itm.dataIndex === 'gift'">
                          {{ item.giftData.name }}
                        </div>
                        <div v-else>{{ item[itm.dataIndex] }}</div>
                      </a-descriptions-item>
                    </a-descriptions>
                  </div>
                </div>

                <tk-flex class="m-b-24">
                  <div class="font-12 unshrink" style="color: #363B45" >截止日期：</div>
                  <div class="fill">
                    {{ pageData.deadline | day }}
                  </div>
                </tk-flex>

                <tk-flex>
                  <div class="font-12 unshrink" style="color: #363B45" >是否邮寄：</div>
                  <div class="fill">{{ pageData.pinkage ? '是' : '否' }}</div>
                </tk-flex>
              </div>

              <div v-if="pageData.giftType === '2'" >
                <a-table
                  v-if="device !== 'mobile'"
                  style="width: 100%" :columns="columnsRegion" :data-source="dataRegion" bordered :pagination="false" :scroll="{x: 600}" size="small">
                  <span slot="index" slot-scope="text, record, index">{{ index + 1 }}</span>
                  <div slot="agent" slot-scope="text, record, index">
                    <SelectAgent v-if="record.editable" placeholder="请选择" :value="record.agent" val="nickName" :record="record" allowClear showSearch @change="(e)=> changeAgent(e, index)" style="width: 100%" ></SelectAgent>
                    <!-- <ak-type-input v-if="record.editable" v-model="record.agent" class="hide-label" :field="agentField" style="margin-bottom: 0;width: 100%" /> -->
                    <span v-else>{{ record.agentData.nickName }}</span>
                  </div>
                  <div class="upLoad" slot="mainImage" slot-scope="text, record">
                    <ak-type-input v-if="record.editable" v-model="record.mainImage" class="hide-label" :field="mainImageField" style="margin-bottom: 0;width: 60px;height: 60px" />
                    <viewer v-else-if="text && !record.editable" :images="[text]">
                      <img :src="text" style="width: 40px;height:40px;object-fit:cover;border-radius: 6px;border: 1px solid #DBDDE1;" />
                    </viewer>
                    <span v-else> 暂无 </span>
                  </div>
                  <div slot="image" slot-scope="text">
                    <viewer v-if="text" :images="[text]">
                      <img :src="text" style="width: 40px;height:40px;object-fit:cover;border-radius: 6px;border: 1px solid #DBDDE1;" />
                    </viewer>
                    <span v-else> - </span>
                  </div>
                  <div slot="gift" slot-scope="text, record, index">
                    <SelectGift v-if="record.editable" placeholder="请选择" :value="record.gift" allowClear showSearch @change="(e)=> changeGift(e, index)" style="width: 100%" ></SelectGift>
                    <div v-else>{{ record.giftData.name }}</div>
                    <!-- <ak-type-input v-model="gift" class="hide-label" :field="giftField" style="margin-bottom: 0;width: 100%" /> -->
                  </div>
                  <div slot="pinkage" slot-scope="text, record">
                    <ak-type-input v-if="record.editable" v-model="record.pinkage" class="hide-label" :field="pinkageField" style="margin-bottom: 0;width: 100%" />
                    <span v-else>{{ text === 'true' ? '是' : '否' }}</span>
                  </div>
                  <div slot="deadline" slot-scope="text, record">
                    <ak-type-input v-if="record.editable" v-model="record.deadline" class="hide-label" :field="deadlineField" style="margin-bottom: 0;width: 100%" />
                    <span v-else>{{ text | day }}</span>
                  </div>
                  <div slot="action" slot-scope="text, record" >
                    <a @click="changeMainImage(record)" >修改主图</a>
                  </div>
                </a-table>
                <div v-else>
                  <a-descriptions bordered v-for="(item,index) in dataRegion" :key="index" style="margin-bottom: 20px">
                    <a-descriptions-item
                      v-for="( itm, i) in columnsRegion" :key="`item${i}`"
                      :label="itm.title"
                    >
                      <span v-if="ite.dataIndex === 'index'">{{ index + 1 }}</span>
                      <div v-else-if="ite.dataIndex === 'agent'">
                        <SelectAgent v-if="item.editable" placeholder="请选择" :value="item.agent" val="nickName" :item="item" allowClear showSearch @change="(e)=> changeAgent(e, index)" style="width: 100%" ></SelectAgent>
                        <span v-else>{{ item.agentData.nickName }}</span>
                      </div>
                      <div class="upLoad" v-else-if="ite.dataIndex === 'mainImage'">
                        <ak-type-input v-if="item.editable" v-model="item.mainImage" class="hide-label" :field="mainImageField" style="margin-bottom: 0;width: 60px;height: 60px" />
                        <viewer v-else-if="item[itm.dataIndex] && !item.editable" :images="[item[itm.dataIndex]]">
                          <img :src="item[itm.dataIndex]" style="width: 40px;height:40px;object-fit:cover;border-radius: 6px;border: 1px solid #DBDDE1;" />
                        </viewer>
                        <span v-else> 暂无 </span>
                      </div>
                      <div v-else-if="ite.dataIndex === 'image'">
                        <viewer v-if="item[itm.dataIndex]" :images="[item[itm.dataIndex]]">
                          <img :src="item[itm.dataIndex]" style="width: 40px;height:40px;object-fit:cover;border-radius: 6px;border: 1px solid #DBDDE1;" />
                        </viewer>
                        <span v-else> - </span>
                      </div>
                      <div v-else-if="ite.dataIndex === 'gift'">
                        <SelectGift v-if="item.editable" placeholder="请选择" :value="item.gift" allowClear showSearch @change="(e)=> changeGift(e, index)" style="width: 100%" ></SelectGift>
                        <div v-else>{{ item.giftData.name }}</div>
                      </div>
                      <div v-else-if="ite.dataIndex === 'pinkage'">
                        <ak-type-input v-if="item.editable" v-model="item.pinkage" class="hide-label" :field="pinkageField" style="margin-bottom: 0;width: 100%" />
                        <span v-else>{{ item[itm.dataIndex] === 'true' ? '是' : '否' }}</span>
                      </div>
                      <div v-else-if="ite.dataIndex === 'deadline'">
                        <ak-type-input v-if="item.editable" v-model="item.deadline" class="hide-label" :field="deadlineField" style="margin-bottom: 0;width: 100%" />
                        <span v-else>{{ item[itm.dataIndex] | day }}</span>
                      </div>
                      <div v-else-if="ite.dataIndex === 'action'">
                        <a @click="changeMainImage(item)" >修改主图</a>
                      </div>
                      <div v-else>{{ item[itm.dataIndex] }}</div>
                    </a-descriptions-item>
                  </a-descriptions>
                </div>
              </div>
            </div>
          </template>
        </Layout>
        <Basic :visible.sync="showBasic" :record="pageData" @refresh="refresh" ></Basic>
        <Accredit v-if="showAccredit" :record="pageData" :vm="this" ></Accredit>
        <Gift v-if="showGift" :record="pageData" :vm="this" ></Gift>
      </div>
    </a-spin>

    <!-- 弹框 -->
    <a-modal
      :title="'修改主图'"
      :confirmLoading="confirmLoading"
      :visible="areaModal"
      @ok="save"
      @cancel="
        () => {
          areaModal = !areaModal;
          area = {};
        }
      "
    >
      <ak-type-input v-model="mainImage" :field="mainImageField" hideLabel style="width: 100%" />
    </a-modal>

  </div>
</template>
<script>
import Layout from '../components/layout.vue'
import publicHeader from '../../components/publicHeader.vue'
import Basic from './component/basic.vue'
import Accredit from './component/accredit.vue'
import Gift from './component/gift.vue'
import Area from './component/area.vue'
export default {
  components: {
    publicHeader,
    Layout,
    Basic,
    Area,
    Accredit,
    Gift
  },
  data () {
    return {
      loading: true, // 加载动画遮罩
      pageData: {},
      menuList: [
        {
          name: '基本信息'
        },
        {
          name: '授权代理商'
        },
        {
          name: '买赠设置'
        }
      ],
      key: 0,
      showBasic: false,
      warZone: '',
      region: '',
      agentList: [],
      showAccredit: false,
      showGift: false,
      columns: [
        {
          title: '图片',
          dataIndex: 'image',
          key: 'image',
          scopedSlots: { customRender: 'image' },
          width: 100
        },
        {
          title: '名称',
          dataIndex: 'gift',
          key: 'gift',
          scopedSlots: { customRender: 'gift' },
          width: 300
        },
        {
          title: '数量',
          dataIndex: 'number',
          key: 'number',
          width: 80
        },
        {
          title: '成本价',
          key: 'costPrice',
          dataIndex: 'costPrice',
          scopedSlots: { customRender: 'costPrice' },
          width: 100
        },
        {
          title: '售价',
          key: 'price',
          dataIndex: 'price',
          scopedSlots: { customRender: 'price' },
          width: 100
        }
      ],
      data: [
        {
          image: '',
          gift: '',
          number: '1件',
          costPrice: '',
          price: ''
        }
      ],
      columnsRegion: [
        {
          title: '序号',
          dataIndex: 'index',
          key: 'index',
          scopedSlots: { customRender: 'index' },
          width: 70
        },
        {
          title: '代理商',
          dataIndex: 'agent',
          key: 'agent',
          scopedSlots: { customRender: 'agent' },
          width: 150
        },
        {
          title: '买赠主图',
          dataIndex: 'mainImage',
          key: 'mainImage',
          scopedSlots: { customRender: 'mainImage' },
          width: 100
        },
        {
          title: '赠品图片',
          dataIndex: 'image',
          key: 'image',
          scopedSlots: { customRender: 'image' },
          width: 100
        },
        {
          title: '赠品名称',
          dataIndex: 'gift',
          key: 'gift',
          scopedSlots: { customRender: 'gift' },
          width: 150
        },
        {
          title: '数量',
          dataIndex: 'number',
          key: 'number',
          width: 80
        },
        {
          title: '赠品售价',
          key: 'price',
          dataIndex: 'price',
          scopedSlots: { customRender: 'price' },
          width: 100
        },
        {
          title: '赠品邮寄',
          key: 'pinkage',
          dataIndex: 'pinkage',
          scopedSlots: { customRender: 'pinkage' },
          width: 120
        },
        {
          title: '截止日期',
          key: 'deadline',
          dataIndex: 'deadline',
          scopedSlots: { customRender: 'deadline' },
          width: 250
        },
        {
          title: '操作',
          key: 'action',
          scopedSlots: { customRender: 'action' },
          width: 100
        }
      ],
      dataRegion: [
      ],
      cacheData: [],
      regionObj: {
        objectId: '',
        agent: '',
        agentData: {},
        mainImage: '',
        image: '',
        gift: '',
        giftData: {},
        number: '1件',
        price: '',
        pinkage: '',
        deadline: ''
      },
      confirmLoading: false,
      areaModal: false, // 弹框
      changeId: '',
      mainImage: '', // 主图
      mainImageField: {
        name: 'mainImage',
        type: 'Image',
        validators: [
          (val) => val ? null : '不可为空'
        ]
      }
    }
  },
  watch: {
    region (val) {
      this.agentList = []
      if (val) {
        this.getAgent()
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    // 初始化菜单按钮
    async init () {
      try {
        await this.getData()
        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },
    //
    async changeMainImage (data) {
      console.log(data)
      this.changeId = data.objectId
      this.mainImage = data.mainImage
      this.areaModal = true
    },
    // 保存
    async save () {
      try {
        if (this.mainImage === '') {
          this.$notification['warning']({
            message: '警告',
            description: '内容不可为空'
          })
          return
        }
        this.confirmLoading = true
        await this.$tkParse.put(`/classes/winWinMerchantProduct/${this.changeId}`, {
          mainImage: this.mainImage
        })
        this.$notification['success']({
          message: '成功',
          description: '保存成功'
        })
        this.mainImage = ''
        this.areaModal = false
        this.confirmLoading = false
        this.refreshGift()
      } catch (error) {
        console.log(error)
        this.confirmLoading = false
        this.$notification['error']({
          message: '设置失败',
          description: '网络错误,请重试'
        })
      }
    },
    // 获取数据
    async getData () {
      const { data } = await this.$tkParse.get(`/classes/commodity/${this.$route.query.id}`, {
        params: { include: 'series,voltage,capacity,gift' }
      })
      data.details = data.details.replace(/<img/g, '<img style="max-width:100%;height:auto"')
      if (data.giftType === '1') {
        this.data[0] = {
          image: data.gift.image,
          gift: data.gift.objectId,
          giftData: data.gift,
          number: '1件',
          costPrice: data.gift.costPrice,
          price: data.gift.price
        }
      }
      this.pageData = data
      if (data.giftType === '2') {
        this.getGiftRegion()
      }
    },
    // 刷新商品
    refresh () {
      this.getData()
    },
    // 刷新代理商
    refreshAgent () {
      this.agentList = []
      this.getAgent()
    },
    // 刷新买赠
    refreshGift () {
      this.getData()
    },
    // 获取代理商
    async getAgent () {
      const { data } = await this.$tkParse.get('/classes/winWinMerchantProduct', {
        params: {
          include: 'winWinMerchant',
          limit: 50000,
          where: {
            isDelete: false,
            commodity: this.pageData.objectId,
            winWinMerchant: {
              $inQuery: {
                where: {
                  regional: this.region
                },
                className: '_User'
              }
            }
          }
        }
      })
      this.agentList = data.results
    },
    async getGiftRegion () {
      this.dataRegion = []
      let { data: res } = await this.$tkParse.get('/classes/winWinMerchantProduct', {
        params: {
          include: 'winWinMerchant,gift',
          limit: 1000,
          where: {
            isDelete: { $ne: true },
            commodity: this.pageData.objectId,
            gift: {
              // 不为空
              $exists: true
            }
          }
        }
      })
      if (res.results.length === 0) {
        return
      }
      // 循环给dataRegion赋值
      res.results.forEach(item => {
        let obj = JSON.parse(JSON.stringify(this.regionObj))
        obj.agent = item.winWinMerchant.objectId
        obj.agentData = item.winWinMerchant
        obj.gift = item.gift.objectId
        obj.giftData = item.gift
        obj.image = item.gift.image
        obj.costPrice = item.gift.costPrice
        obj.price = item.gift.price
        obj.mainImage = item.mainImage
        obj.pinkage = item.pinkage === true ? 'true' : 'false'
        obj.deadline = item.deadline
        obj.objectId = item.objectId
        this.dataRegion.push(obj)
      })
    },
    edit () {
      if (this.key === 0) {
        this.showBasic = true
      }
      if (this.key === 1) {
        this.showAccredit = true
      }
      if (this.key === 2) {
        this.showGift = true
      }
    }
  }
}
</script>
<style lang="scss" scoped>

</style>
